import {useMemo} from "react";

type ChallengeEntry = {
  id: string;
  participationCreatedAt?: number | null;
};

type StateEntry = {
  isCompleted?: boolean | null;
  lastAttempt?: {startedAt?: number | null} | null;
};

export default function useSortedChallenges<T extends ChallengeEntry>(
  challenges: T[],
  statesMap: Map<unknown, StateEntry> | undefined,
): [active: T[], completed: T[]] {
  return useMemo(() => {
    if (!statesMap) return [challenges, []];

    const active: T[] = [];
    const completed: T[] = [];

    for (const ch of challenges) {
      if (statesMap.get(ch.id)?.isCompleted) {
        completed.push(ch);
      } else {
        active.push(ch);
      }
    }

    active.sort((a, b) => {
      const aDate = a.participationCreatedAt as number | undefined;
      const bDate = b.participationCreatedAt as number | undefined;
      if (!aDate && !bDate) return 0;
      if (!aDate) return 1;
      if (!bDate) return -1;
      return aDate - bDate;
    });

    completed.sort((a, b) => {
      const aDate = statesMap.get(a.id)?.lastAttempt?.startedAt as number | undefined;
      const bDate = statesMap.get(b.id)?.lastAttempt?.startedAt as number | undefined;
      if (!aDate && !bDate) return 0;
      if (!aDate) return 1;
      if (!bDate) return -1;
      return bDate - aDate;
    });

    return [active, completed];
  }, [challenges, statesMap]);
}
